<div
	class="card border-0 shadow-sm rounded-3 mx-auto"
	style="max-width: 500px; overflow: hidden;"
>
	<!-- Encabezado con avatar -->
	<div class="text-center bg-light py-4 position-relative">
		<div class="position-relative d-inline-block">
			<img
				[src]="'assets/img/avatars/9.png'"
				alt="Foto de perfil"
				class="rounded-circle border shadow-sm object-fit-cover"
				style="width: 130px; height: 130px; object-fit: cover;"
			/>
		</div>

		<!-- Nombre -->
		<div class="mt-3 d-flex justify-content-center align-items-center gap-2 flex-wrap">
			<ng-container *ngIf="!editField.name; else usernameEdit">
				<h5 class="mb-0 fw-semibold">{{ name }}</h5>
				<button
					pButton
					type="button"
					icon="pi pi-pencil"
					class="p-button-rounded p-button-text p-button-sm"
					(click)="toggleEdit('name')"
					title="Editar nombre"
					style="height: 2rem; width: 2rem;"
				></button>
			</ng-container>

			<ng-template #usernameEdit>
				<div class="input-group input-group-sm" style="max-width: 260px;">
					<input
						type="text"
						pInputText
						[(ngModel)]="name"
						placeholder="Nombre"
						class="form-control"
					/>
					<button
						pButton
						type="button"
						icon="pi pi-check"
						class="p-button-success p-button-sm"
						(click)="toggleEdit('name')"
						title="Guardar"
					></button>
				</div>
			</ng-template>
		</div>

		<p class="text-muted small mt-2 mb-0 d-flex justify-content-center align-items-center">
			<i class="pi pi-envelope me-1"></i>
			<span>{{ email }}</span>
		</p>
		<p class="text-muted small mb-0">Cliente: <span class="fw-semibold">{{ idcliente }}</span></p>
	</div>

	<!-- Cuerpo -->
	<div class="card-body px-4 py-4">

		<!-- Contraseña -->
		<div class="mb-4">
			<h6 class="text-uppercase text-muted small fw-bold mb-3">
				<i class="pi pi-lock text-primary me-1"></i> Seguridad
			</h6>

			<div class="d-flex align-items-center justify-content-between mb-3">
				<span class="text-muted small">Editar contraseña</span>
				<p-inputSwitch
					[(ngModel)]="changePassword"
					onLabel="Sí"
					offLabel="No"
					name="editPassword"
				></p-inputSwitch>
			</div>

			<div *ngIf="changePassword" class="bg-light rounded-3 p-3 border">
				<div class="mb-3">
					<label class="small text-muted mb-1 d-block">Nueva contraseña</label>
					<input
						type="password"
						pInputText
						[(ngModel)]="password"
						name="newPassword"
						placeholder="Nueva contraseña"
						class="form-control form-control-sm"
					/>
				</div>

				<div class="mb-2">
					<label class="small text-muted mb-1 d-block">Confirmar contraseña</label>
					<input
						type="password"
						pInputText
						[(ngModel)]="passwordConfirm"
						name="confirmPassword"
						placeholder="Confirmar contraseña"
						class="form-control form-control-sm"
					/>
				</div>

				<div
					*ngIf="password && passwordConfirm && password !== passwordConfirm"
					class="text-danger small mt-1"
				>
					<i class="pi pi-exclamation-triangle me-1"></i>
					Las contraseñas no coinciden.
				</div>
			</div>
		</div>

		<hr class="text-muted opacity-25" />

		<!-- Acciones -->
		<div class="d-flex flex-column gap-2">
			<button
				pButton
				type="button"
				label="Guardar cambios"
				icon="pi pi-save"
				class="p-button-primary"
				(click)="saveAll()"
			></button>

			<button
				pButton
				type="button"
				label="Restablecer"
				icon="pi pi-refresh"
				class="p-button-outlined p-button-secondary"
				(click)="reset()"
			></button>
		</div>
	</div>
</div>
